import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect () {
    const { style } = document.body

    if (this.element.checked) {
      style.setProperty("--safe-area-inset-top", "calc(2 * var(--space-y))")
      style.setProperty("--safe-area-inset-right", "calc(8 * var(--space-x))")
      style.setProperty("--safe-area-inset-bottom", "calc(8 * var(--space-y))")
      style.setProperty("--safe-area-inset-left", "calc(2 * var(--space-x))")
      style.setProperty("--safe-area-inset-color", "var(--brand-secondary)")
    } else {
      style.removeProperty("--safe-area-inset-top")
      style.removeProperty("--safe-area-inset-right")
      style.removeProperty("--safe-area-inset-bottom")
      style.removeProperty("--safe-area-inset-left")
      style.removeProperty("--safe-area-inset-color")
    }
  }
}
